export class CurrentConference {
    id: number;
    name: string;
}